import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import StaticShell from '../Static/StaticShell';
import { regionFromPathname } from '../../utils/regionFromPath';
import { useI18n } from '../../hooks/useI18n';
import SEO from '../../components/seo/SEO';
import ManagedInlineBanner from '../../components/ads/ManagedInlineBanner';
import { bannerAds } from '../../data/staticAds';

const Form = styled.form`
  margin-top: 1.5rem;
  max-width: 24rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const Input = styled.input`
  padding: 0.65rem 0.85rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  border: 2px solid ${({ theme }) => theme.colors.border};
  font-size: ${({ theme }) => theme.fontClamp.sm};
`;

const TextArea = styled.textarea`
  min-height: 100px;
  padding: 0.65rem 0.85rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  border: 2px solid ${({ theme }) => theme.colors.border};
  font-size: ${({ theme }) => theme.fontClamp.sm};
  font-family: inherit;
`;

const Btn = styled.button`
  padding: 0.65rem 1.25rem;
  border: none;
  border-radius: ${({ theme }) => theme.radiusSm};
  background: ${({ theme }) => theme.colors.crimson};
  color: ${({ theme }) => theme.colors.crimsonForeground};
  font-weight: 700;
  cursor: pointer;
`;

export default function ContactPage() {
  const region = regionFromPathname(useLocation().pathname);
  const { t } = useI18n();
  const [sent, setSent] = useState(false);
  return (
    <>
      <SEO
        region={region}
        path="/contact"
        title={t('static.contact.title', 'Contact')}
        description={t('static.contact.lead', 'Questions or feedback? Send us a message.')}
      />
      <StaticShell title={t('static.contact.title', 'Contact')} region={region}>
        <>
        <p>{t('static.contact.lead', 'Questions or feedback? Send us a message.')}</p>
        <div style={{ margin: '1.5rem 0' }}>
          <ManagedInlineBanner pageKey="contact" fallbackAd={bannerAds[1] ?? bannerAds[0]} variant="inline" />
        </div>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            setSent(true);
          }}
        >
          <Input name="email" type="email" placeholder={t('static.contact.email', 'Email')} required />
          <TextArea name="message" placeholder={t('static.contact.message', 'Message')} required />
          <Btn type="submit">{sent ? t('common.thanks', 'Thanks') : t('static.contact.send', 'Send')}</Btn>
        </Form>
        </>
      </StaticShell>
    </>
  );
}
